import { render, staticRenderFns } from "./Vacances.vue?vue&type=template&id=76faa6ae&"
import script from "./Vacances.vue?vue&type=script&lang=js&"
export * from "./Vacances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports